import React from "react";
import Header from "../common/Header/header";
import Footer from "../common/Footer/footer.jsx";
import "../ResearchProjects/researchProjects.css";

const ResearchProjectsPage = () => {
  const projects = [
    {
      title:
        "Identification and assessment of groundwater potential zones in (semi)-arid regions for Managed Aquifer Recharge in Rajasthan.",
      sponsor: "Govt. of Rajasthan",
      "Sanctioned Year": "2023-24",
      amount: "120.00 Lakhs",
      role: "Co-PI",
    },
  ];

  return (
    <>
      <Header />
      <div className="research-page-background">
        <div className="projects">
          <ol className="projects-list">
            {projects.map((project, index) => (
              <div key={index}>
                <li>
                  <strong>Title:- </strong>
                  {project.title}
                </li>
                <div className="project-detail">
                  {Object.entries(project)
                    .slice(1)
                    .map(([key, value], index) => (
                      <div key={index}>
                        <strong>
                          {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                        </strong>
                        {value}
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </ol>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ResearchProjectsPage;
